(function () {
    'use strict';

    angular
        .module('app.widgets')
        .directive('spWidgetHeader', spWidgetHeader);

    /* @ngInject */
    function spWidgetHeader() {
        //Usage:
        //<div sp-widget-header title="vm.map.title"></div>
        // Creates:
        // <div sp-widget-header=""
        //      title="Movie"
        //      allow-collapse="true"> </div>
        var directive = {
            scope: {
                'title': '@',
                'subtitle': '@',
                'rightText': '@',
                'allowCollapse': '@'
            },
            template: '<div class="widget-head truncate" >' +
                '<div class="widget-icons pull-right" data-ng-if="allowCollapse">' +
                '<a data-sp-widget-minimize aria-label="expand or collapse"></a>' +
                '</div>' +
                '<div class="page-title pull-left">{{title}}</div>' +
                '<small class="page-title-subtle" ng-show="subtitle">({{subtitle}})</small>' +
                '<div class="widget-icons pull-right"></div>' +
                '<small class="pull-right page-title-subtle" ng-show="rightText">{{rightText}}</small>' +
                '<div class="clearfix"></div>' +
                '</div>',
            restrict: 'EA'
        };
        return directive;
    }
})();
